
import mixin from "@/mixin";
import Vue from "vue";
import Component, { mixins } from "vue-class-component";
import { version } from '@/../package.json';
@Component
export default class Footer extends mixins(mixin) {
  versionApp = version;
}
